import { useMantineColorScheme, Button } from "@mantine/core";
import React from "react";
import { FaSun, FaMoon } from "react-icons/fa";

export function ThemeSwitch() {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const dark = colorScheme === "dark";

  return (
    <Button
      title="Toggle color scheme"
      size="sm"
      variant="subtle"
      sx={{
        fontSize: 14,
        fontWeight: 400,
        color: dark ? "#FFF" : "#25262B",
        "&:hover": {
          backgroundColor: "rgba(68,215,182,0.10) !important",
          color: "#44D7B6",
        },
      }}
      onClick={() => {
        toggleColorScheme();
        navigator.serviceWorker.ready.then((registration) => {
          registration?.active?.postMessage({
            type: "COLOR_SCHEME_CHANGE",
            colorScheme: colorScheme === "dark" ? "light" : "dark",
          });
        });
      }}
    >
      {dark ? <FaSun size={18} /> : <FaMoon size={18} />}
    </Button>
  );
}
